export const requestIdHeaderName = 'X-Request-Id';
/**
 * When making requests to the Sage API in environments that are protected by the VPN,
 * and you aren't in the VPN, this header should be set to the secret value to bypass the firewall.
 */
export const sageAppIdHeaderName = 'x-sage-app-id';
//# sourceMappingURL=headers.js.map